var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie-player',{ref:"lottie",staticClass:"mx-auto",staticStyle:{"width":"320px"},attrs:{"id":"webDev","mode":"normal","src":_vm.src,"autoplay":"","loop":"true"}})
}
var staticRenderFns = []

export { render, staticRenderFns }